import { render, staticRenderFns } from "./ChatArrowDownSvg.vue?vue&type=template&id=59b0ea9c&"
import script from "./ChatArrowDownSvg.vue?vue&type=script&lang=js&"
export * from "./ChatArrowDownSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports